// apps/nos/client/src/lib/sentryInit.ts
// Imported first thing in main.tsx — runs Sentry.init() once at module load.

import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
// Vite's MODE is the literal --mode flag value ("production" for the prod
// build, "development.ec2" for the dev-EC2 build, "development" for the
// local Vite dev server). PROD is true only for exact "production" mode,
// so it can't distinguish development from development.ec2.
const mode = import.meta.env.MODE;
const isProd = mode === "production";
const isDevEc2 = mode === "development.ec2";
const enableDev = import.meta.env.VITE_SENTRY_ENABLE_DEV === "1";
const enabled = !!dsn && (isProd || enableDev);

// Three distinct environments: production, dev-ec2, development.
const environment = isProd ? "production" : isDevEc2 ? "dev-ec2" : "development";

if (enabled) {
  const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0.1");

  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.1,
    sendDefaultPii: true,
    sampleRate: 1.0,
  });
  console.log(
    `[sentry] initialized environment=${environment} traces=${tracesSampleRate}`,
  );
} else {
  console.log(
    `[sentry] disabled (dsn=${dsn ? "set" : "unset"}, MODE=${mode}, VITE_SENTRY_ENABLE_DEV=${import.meta.env.VITE_SENTRY_ENABLE_DEV ?? "<unset>"})`,
  );
}

export const sentryEnabled = enabled;
export { Sentry };
